export default __webpack_public_path__ + "static/media/doctor5.7383a9f2.webp";